import useSupplementCategories from './useSupplementCategories';

const useSupplementCategoryById = (categoryId?: number | null) => {
  const supplementCategories = useSupplementCategories();
  return supplementCategories.find(category => category.id === categoryId);
};

export default useSupplementCategoryById;
